import { gradeColor, scoreToGrade } from "../lib/grade";

interface Props {
  score: number | null | undefined;
  grade: string | null | undefined;
  size?: number;
}

/** Compact circular score ring (grade letter + number) for queue rows/cards. */
export default function ScoreBadge({ score, grade, size = 46 }: Props) {
  const g = grade ?? scoreToGrade(score);
  const color = gradeColor(g);
  const stroke = 3.5;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(100, score ?? 0));
  const dash = (pct / 100) * c;
  const center = size / 2;

  if (score == null && !g) {
    return <span className="score-badge-empty" style={{ width: size, height: size }}>—</span>;
  }

  return (
    <span className="score-badge" style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle cx={center} cy={center} r={r} fill="none" stroke="var(--ring-track)" strokeWidth={stroke} />
        <circle
          cx={center}
          cy={center}
          r={r}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={`${dash} ${c}`}
          transform={`rotate(-90 ${center} ${center})`}
        />
      </svg>
      <span className="score-badge-text">
        <span className="sb-grade" style={{ color }}>{g ?? "?"}</span>
        <span className="sb-score">{score ?? "—"}</span>
      </span>
    </span>
  );
}
